import React, { useState, useEffect } from 'react';
import { fetchGridDetails, fetchDropDownDetails, updateGridDetails } from '../service/DirectorAPI.js';
import { Select } from 'antd';
import { encryptStorage } from '../constant.js';

const Grid = () => {


    const [ProjectFilter, setProjectFilter] = useState("");
    const [skillFilter, setSkillFilter] = useState("");
    const [ratingFilter, setratingFilter] = useState("");
    const [billingFilter, setbillingFilter] = useState("");
    const [experienceFilter, setexperienceFilter] = useState("");
    const [gridData, setGridData] = useState([]);
    const [dropDownData, setDropDrownData] = useState([]);
    const [tempSearch, setTempSearch] = useState('');
    const [editData, setEditData] = useState({
        task_name: "",
        billing: "",
        taskId: [],
        type: "",
        tags: [],
        ETA: 0,
        comments: '',
        date: ""
    });
    const [errorMsg, setErrorMsg] = useState({
        title: '',
        estHrs: '',
        taskType: '',
        notes: '',
        tags: '',
    });

    const [weekNo, setWeekNo] = useState([])
    const [editDisplay, setEditDisplay] = useState(false)
    const [recordCount, setRecordCount] = useState(0);
    const [filterDisplay, setFilterDisplay] = useState('none');
    const [numberOfPages, setNumberOfPages] = useState(1);
    const [entireWeekRange, setEntireWeekRange] = useState({ start_date: '', end_date: '' })
    const [isLoading, setIsLoading] = useState(false);
    const [weekRange, setWeekRange] = useState([{ start: "", end: "", status: "" },
    { start: "", end: "", status: "" },
    { start: "", end: "", status: "" }])

    const [gridActions, setGridActions] = useState({
        "startDate": "",
        "endDate": "",
        "microsoftUserIds": [],
        "searchData": "",
        "skill": "",
        "project_name": "",
        "domain": "",
        "previousEvaluation_id": encryptStorage.getItem('PreviousEvaluationId'),
        "pageNumber": 1,
        "nameOrder": "",
        "expOrder": "",
        "rating": "",
        "experience": "",
        "billing": ""
    });



    // // PC_NO_03
    useEffect(() => {
        // PC_NO_04
        fetchDropDown();
    }, []);


    useEffect(() => {
        fetchGrid();
    }, [gridActions])

    const fetchDropDown = async () => {
        let fetchedDropDownData = await fetchDropDownDetails();
        if (fetchedDropDownData.status === 200) {
            setDropDrownData(fetchedDropDownData.data);
        }
    }

    const fetchGrid = async () => {
        // PC_NO_05
        setIsLoading(true)
        const fetchedData = await fetchGridDetails(gridActions);
        if (fetchedData.status === 200) {
            setGridData(fetchedData.data.totalResponse);
            setEntireWeekRange(fetchedData?.data?.dateRange);
            setWeekNo(fetchedData?.data?.weekData?.number);
            setWeekRange(fetchedData?.data?.weekData?.range);
            let tepmTotalRecords = fetchedData?.data?.count;
            let tempNumberOfPages = Math.ceil(tepmTotalRecords / 30);
            setRecordCount(parseInt(tepmTotalRecords));
            setNumberOfPages(tempNumberOfPages);
        }
        setIsLoading(false)
    }

    const handleOnChange = (e) => {
        e.target.name === 'domain' ? setGridActions({ ...gridActions, ['pageNumber']: 1, [e.target.name]: e.target.value }) : setGridActions({ ...gridActions, [e.target.name]: e.target.value });

    };

    const editHandleOnCHange = (e) => {
        setEditData({ ...editData, [e.target.name]: e.target.value })
    }

    const clearFilter = () => {
        setGridActions({
            ...gridActions,
            skill: '',
            project_name: '',
            experience: '',
            billing: '',
            rating: '',
            startDate: '',
            endDate: ''
        });
        setProjectFilter('');
        setSkillFilter('');
        setbillingFilter('');
        setexperienceFilter('');
        setratingFilter('');
    };
    const sortAsc = (e) => {
        e.target.id === 'nameOrder' ? setGridActions({ ...gridActions, ['nameOrder']: 'asc', ['expOrder']: '' }) : setGridActions({ ...gridActions, ['nameOrder']: '', ['expOrder']: 'asc' })
    };

    const sortDesc = (e) => {
        e.target.id === 'nameOrder' ? setGridActions({ ...gridActions, ['nameOrder']: 'desc', ['expOrder']: '' }) : setGridActions({ ...gridActions, ['nameOrder']: '', ['expOrder']: 'desc' })
    };


    const [currentClubbedId, setCurrentClubbedId] = useState(false);
    const [multiTags, setMultiTags] = useState([]);
    const [options, setOptions] = useState([]);

    const handleChange = (e) => {
        setMultiTags(e)
    }


    // function editPopUp(id) {
    //     
    //     if (id !== undefined) {
    //         let arr = id?.split(',');
    //         let edit = gridData[arr[0]]?.Todos[arr[1]]?.Weeks[arr[2]].tasks[arr[3]];
    //         let userTagOptions = [];
    //         gridData[arr[0]].tagCollection?.documents?.forEach((data) =>  { userTagOptions.push({ label :  data.tagName, value : data._id }) } );
    //         setOptions(userTagOptions);
    //         let tempMultiTags = Array.from(new Set(edit?.tags?.map(data => data?._id).filter(Boolean)));
    //         setMultiTags(tempMultiTags)
    //         let taskIdArray = edit?.taskId?.length > 1 ?  Array.from(new Set(edit?.taskId)) : []
    //         let clubbed = taskIdArray?.length > 1 ? true : false;
    //         setCurrentClubbedId(clubbed);



    //         if (edit !== undefined && edit) {
    //             let currentDate = new Date();
    //             let editDate = new Date(edit.date);
    //             let editDateOnly = new Date(editDate.getFullYear(), editDate.getMonth(), editDate.getDate());
    //             let currentDateOnly = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    //             let check = editDateOnly.getTime() >= currentDateOnly.getTime();
    //             if (check) {
    //                 setEditData(edit);
    //                 setEditDisplay(true)
    //             }
    //         }
    //     }
    // }
    // async function updateDetails() {
    //     let flag = true;
    //     let tempErrorObject = {
    //         title: '',
    //         estHrs: '',
    //         taskType: '',
    //         notes: '',
    //         tags: '',
    //     }
    //     if (!editData.task_name) {
    //         tempErrorObject.title = "*Title Required";
    //         flag = false
    //     }

    //     if (!currentClubbedId) {
    //         if (!editData.ETA) {
    //             tempErrorObject.estHrs = "*Estimated Effort of this work!";
    //             flag = false
    //         }
    //         if (editData.ETA) {
    //             if (editData.ETA % 0.25 !== 0) {
    //                 tempErrorObject.estHrs = "*Estimated Effort should be in factor of 0.25";
    //                 flag = false
    //             }
    //         }

    //         // if(editData.status === "Completed"){
    //         if (!editData.comments) {
    //             tempErrorObject.notes = "*Additional Notes Required!";
    //             flag = false
    //         }
    //         // }
    //         if (!editData.type) {
    //             tempErrorObject.taskType = "*Type of task is Required!";
    //             flag = false
    //         }
    //         if (!multiTags.length) {
    //             tempErrorObject.tags = "*Tags Required!";
    //             flag = false
    //         }
    //     }


    //     setErrorMsg(tempErrorObject);
    //     let updateObj = {}
    //     if (currentClubbedId) {
    //         updateObj = {
    //             todoIds: editData.taskId,
    //             todoObject: {
    //                 title: editData.task_name
    //             }
    //         }
    //     }
    //     else {
    //         updateObj = {
    //             todoIds: editData.taskId,
    //             todoObject: {
    //                 title: editData.task_name,
    //                 tags: multiTags,
    //                 eta: editData.ETA,
    //                 type: editData.type,
    //                 comments: editData.comments
    //             }
    //         }
    //     }
    //     if (flag) {
    //         setIsLoading(true);
    //         const updateData = await updateGridDetails(updateObj);
    //         if (updateData.status === 200) {
    //             setEditData({
    //                 ...editData,
    //                 ['task_name']: "",
    //                 ['billing']: "",
    //                 ['taskId']: [],
    //                 ['type']: "",
    //                 ['ETA']: 0,
    //                 ['comments']: '',
    //                 ['date']: ""
    //             })
    //             setEditDisplay('none');
    //             setCurrentClubbedId(false);
    //             setMultiTags([]);
    //             fetchGrid();
    //             clearErrorMessages();
    //         }
    //         else {
    //             setIsLoading(false);
    //         }
    //     }
    // }

    const bindAllPracticesDropDownData = () => {
        let practiseDropDowns = dropDownData?.domain
        practiseDropDowns?.sort((a, b) => a.domain.localeCompare(b.domain));
        return practiseDropDowns?.map((element, index) => {
            return <option key={"practice" + index} value={element.domain}>{element.domain}</option>
        });
    }

    const bindSkillSetDropDownData = () => {
        let skillDropDowns = dropDownData?.skill;
        skillDropDowns?.sort((a, b) => a.emp_skills.localeCompare(b.emp_skills));
        return skillDropDowns?.map((element, index) => {
            return <option key={"skillSet" + index} value={element.emp_skills}>{element.emp_skills}</option>
        });
    }

    const bindProjectsDropDownData = () => {
        let projectDropDowns = dropDownData?.projects;
        projectDropDowns?.sort((a, b) => a.project_name.localeCompare(b.project_name));
        return projectDropDowns?.map((element, index) => {
            return <option key={"project" + index} value={element._id}>{element.project_name}</option>
        });
    };

    const getThreeWeeksRange = (startDate, endDate, direction) => {

        const start = new Date(startDate);
        const end = new Date(endDate);

        if (direction === 'next') {
            start.setDate(start.getDate() + 7);
            end.setDate(end.getDate() + 7);
        } else if (direction === 'previous') {
            start.setDate(start.getDate() - 7);
            end.setDate(end.getDate() - 7);
        }


        let formattedStartDate = start.toISOString().split('T')[0];
        let formattedEndDate = end.toISOString().split('T')[0];


        setGridActions({ ...gridActions, ['startDate']: formattedStartDate, ['endDate']: formattedEndDate })
    }

    const clearErrorMessages = () => {
        let clearAllErrorMEssages = {
            title: '',
            estHrs: '',
            taskType: '',
            notes: '',
            tags: '',
        }
        setErrorMsg(clearAllErrorMEssages);

    }

    const bindFunction = () => {

        let rows = [];
        gridData.forEach((employeeData, empIndex) => {
            let iterate = 1;
            let taskIndex = 0;
            if (employeeData.Todos.length != 0) {
                employeeData.Todos.forEach((value, index) => {
                    let empDataEndIndex = employeeData.Todos.length;
                    let weeks = value;
                    let length1 = weeks.Week1.tasks.length
                    let length2 = weeks.Week2.tasks.length
                    let length3 = weeks.Week3.tasks.length
                    let maxLength = Math.max(length1, length2, length3)
                    for (let i = 0; i < maxLength + 1; i++) {
                        if (i < maxLength) {

                            let firstWeekTaskName = weeks.Week1?.tasks[taskIndex]?.task_name;
                            let secondWeekTaskName = weeks.Week2?.tasks[taskIndex]?.task_name;
                            let thirdWeekTaskName = weeks.Week3?.tasks[taskIndex]?.task_name;

                            if (firstWeekTaskName && (firstWeekTaskName.length > 40)) firstWeekTaskName = firstWeekTaskName.substring(0, 50) + '...';

                            if (secondWeekTaskName && (secondWeekTaskName.length > 40)) secondWeekTaskName = secondWeekTaskName.substring(0, 50) + '...';

                            if (thirdWeekTaskName && (thirdWeekTaskName.length > 40)) thirdWeekTaskName = thirdWeekTaskName.substring(0, 50) + '...';

                            let weekOneBillingArray = weeks?.Week1?.tasks[taskIndex]?.billing?.length ? weeks?.Week1?.tasks[taskIndex]?.billing : [];
                            let weekTwoBillingArray = weeks?.Week2?.tasks[taskIndex]?.billing.length ? weeks?.Week2?.tasks[taskIndex]?.billing : [];
                            let weekThreeBillingArray = weeks?.Week3?.tasks[taskIndex]?.billing.length ? weeks?.Week3?.tasks[taskIndex]?.billing : [];

                            let billingResultArray = [].concat(weekOneBillingArray, weekTwoBillingArray, weekThreeBillingArray);

                            let billableCount = 0;
                            let nonBillableCount = 0;

                            if (billingResultArray.length) {
                                billingResultArray.forEach((element) => {
                                    if (element.tagName === "Billable") billableCount++
                                    if (element.tagName === "Non Billable") nonBillableCount++
                                })
                            }

                            let billingResult = '-';

                            if (billableCount > 0 && nonBillableCount == 0) billingResult = 'B';

                            else if (billableCount == 0 && nonBillableCount > 0) billingResult = 'NB';

                            else if (billableCount > 0 && nonBillableCount > 0) billingResult = 'PB';

                            rows.push(
                                <tr className={`${(index == empDataEndIndex - 1) && (i == maxLength - 1) ? ` ` : ``}`}>
                                    <td>

                                        {iterate == 1 && <span className="d-flex">
                                            <img src={employeeData.profile_img_url ? employeeData.profile_img_url : 'Images/logo-person-user-person-icon.jpg'} width="32" height="32" style={{ borderRadius: "20px" }} alt="profile pic" />
                                            <span className="ms-2">
                                                <p className="font-12 m-0 mb-1"><span data-bs-toggle="tool-tip" title={employeeData.employee_name}>{employeeData.employee_name}</span></p>
                                                <p className="font-10 m-0 domain-name">{employeeData.domain}</p>
                                            </span>
                                        </span>}
                                    </td>
                                    <td className="font-12 m-0">{iterate == 1 ? employeeData.experience !== "NA" ? (employeeData.experience != 1 ? employeeData.experience + " Years" : employeeData.experience + " Year") : employeeData.experience : ""}</td>
                                    <td>
                                        {iterate == 1 && employeeData?.skill_names?.split(',')[0] && <span className="d-flex">
                                            <span className="skill-badge font-9 my-auto">{employeeData?.skill_names?.split(',')[0] ? employeeData.skill_names?.split(',')[0] : ""}</span>
                                            {employeeData?.skill_names?.split(',')[1] && <span className="skill-badge-num ms-2 font-9 font-medium" data-bs-toggle="tooltip" data-bs-custom-className="skillTooltip" data-bs-placement="top" title={employeeData.skill_names}>+{employeeData.skill_names?.split(',')?.length - 1} </span>}
                                        </span>}
                                    </td>
                                    <td className={"font-12 m-0"}>{iterate == 1 ? employeeData.rating ? employeeData.rating : "NA" : ""}</td>
                                    <td className={`${(i == maxLength - 1) ? ` ` : ``}`}><span className={`${billingResult == "B" ? `green` : billingResult == "NB" ? "orange" : billingResult == "PB" ? "grey" : billingResult == "-" ? "darkblue" : ''}-badge font-medium font-11`}>{billingResult}</span></td>
                                    {/* <td className={"font-12 m-0" + `${(i == maxLength - 1) ? ` border-bottom` : ``}`}>{value.ProjectName}</td> */}
                                    <td id={`${empIndex},${index},Week1,${i}`} className={"font-12 m-0 " + `${(i == maxLength - 1) ? ` ` : ``}`}
                                        // onClick={(e) => { editPopUp(e.target.id) }}
                                        title={weeks.Week1?.tasks[taskIndex] ? weeks.Week1.tasks[taskIndex].task_name + "" + `(${weeks.Week1.tasks[taskIndex]?.ETA})` : ""} >{firstWeekTaskName ? firstWeekTaskName + "" + `(${weeks.Week1.tasks[taskIndex]?.ETA})` : ""}</td>
                                    <td id={`${empIndex},${index},Week2,${i}`} className={"font-12 m-0 " + `${(i == maxLength - 1) ? ` ` : ``}`}
                                        // onClick={(e) => { editPopUp(e.target.id) }}
                                        title={weeks.Week2?.tasks[taskIndex] ? weeks.Week2.tasks[taskIndex].task_name + "" + `(${weeks.Week2.tasks[taskIndex]?.ETA})` : ""} >{secondWeekTaskName ? secondWeekTaskName + "" + `(${weeks.Week2.tasks[taskIndex]?.ETA})` : ""}</td>
                                    <td id={`${empIndex},${index},Week3,${i}`} className={"font-12 m-0 " + `${(i == maxLength - 1) ? ` ` : ``}`} colSpan={2}
                                        // onClick={(e) => { editPopUp(e.target.id) }}
                                        title={weeks.Week3?.tasks[taskIndex] ? weeks.Week3.tasks[taskIndex].task_name + "" + `(${weeks.Week3.tasks[taskIndex]?.ETA})` : ""} >{thirdWeekTaskName ? thirdWeekTaskName + "" + `(${weeks.Week3.tasks[taskIndex]?.ETA})` : ""}</td>
                                </tr>

                            )
                            iterate = 0;
                            taskIndex++;
                        }
                        else if (i == maxLength) {
                            rows.push(
                                <tr className="border-bottom">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><span className="font-12 m-0 bold-font">Total Hrs:</span> <span className="font-12 m-0 bold-font">{weeks.Week1.totalEta}</span></td>
                                    <td><span className="font-12 m-0 bold-font">Total Hrs:</span> <span className="font-12 m-0 bold-font">{weeks.Week2.totalEta}</span></td>
                                    <td><span className="font-12 m-0 bold-font">Total Hrs:</span> <span className="font-12 m-0 bold-font">{weeks.Week3.totalEta}</span></td>
                                </tr>
                            )
                        }

                    }
                })
            }
            else {
                rows.push(
                    <tr>
                        <td>

                            <span className="d-flex">
                                <img src={employeeData.profile_img_url ? employeeData.profile_img_url : 'Images/logo-person-user-person-icon.jpg'} width="32" height="32" style={{ borderRadius: "20px" }} alt="profile pic" />
                                <span className="ms-2">
                                    <p className="font-12 m-0 mb-1"><span data-bs-toggle="tool-tip" title={employeeData.employee_name}>{employeeData.employee_name}</span></p>
                                    <p className="font-10 m-0 domain-name">{employeeData.domain}</p>
                                </span>
                            </span>
                        </td>
                        <td className="font-12 m-0">{employeeData.experience !== "NA" ? (employeeData.experience != 1 ? employeeData.experience + " Years" : employeeData.experience + " Year") : employeeData.experience}</td>
                        <td>
                            {employeeData?.skill_names?.split(',')[0] && <span className="d-flex">
                                <span className="skill-badge font-9 my-auto">{employeeData?.skill_names?.split(',')[0] ? employeeData.skill_names?.split(',')[0] : ""}</span>
                                {employeeData?.skill_names?.split(',')[1] && <span className="skill-badge-num ms-2 font-9 font-medium" data-bs-toggle="tooltip" data-bs-custom-className="skillTooltip" data-bs-placement="top" title={employeeData.skill_names}>+{employeeData.skill_names?.split(',')?.length - 1}</span>}
                            </span>}
                        </td>
                        <td className={"font-12 m-0"}>{employeeData.rating ? employeeData.rating : "NA"}</td>
                        <td></td>
                        {/* <td className={"font-12 m-0 border-bottom"}></td> */}
                        <td className='centcom-text-align-left'> - </td>
                        <td className='centcom-text-align-left'> - </td>
                        <td className='centcom-text-align-left'> - </td>

                    </tr>
                )
                // if(true){
                //     rows.push(
                //         <tr className="border-bottom">
                //             <td></td>
                //             <td></td>
                //             <td></td>
                //             <td></td>
                //             <td></td>
                //             <td><span class="font-bold">Total Hrs:</span> <span>37</span></td>
                //             <td><span class="font-bold">Total Hrs:</span> <span>36</span></td>
                //             <td><span class="font-bold">Total Hrs:</span> <span>39</span></td>
                //         </tr>
                //     )
                // }
            }
        })
        return rows;
    }
    const handlePagesOnclick = (e) => {
        let tempCurrentPage = gridActions.pageNumber;
        tempCurrentPage = e.target.id === "next-page" ? (tempCurrentPage < numberOfPages ? tempCurrentPage + 1 : tempCurrentPage) : tempCurrentPage;
        tempCurrentPage = e.target.id === "previous-page" ? (tempCurrentPage > 1 ? tempCurrentPage - 1 : tempCurrentPage) : tempCurrentPage;
        tempCurrentPage = e.target.id === "first-page" ? 1 : tempCurrentPage;
        tempCurrentPage = e.target.id === "last-page" && numberOfPages != 0 ? numberOfPages : tempCurrentPage;
        if (gridActions.pageNumber !== tempCurrentPage) {
            setGridActions({
                ...gridActions,
                ['pageNumber']: tempCurrentPage,
            });
        }
    }
    return (
        <div>
            {isLoading ?
                <div className="bg-white loader-style">
                    <div className="spinner-border m-5" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div> :
                <div className="container-fluid mt-4">

                    <div className="col-md-12 bg-color px-4 pt-5">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h1 className="tt-bold font-18">Delivery Tracker</h1>
                            <div>
                                <ul className="nav">
                                    <li className="me-3">
                                        <select className="form-select hive-form-control"
                                            aria-label="Default select example" name="domain" value={gridActions.domain} onChange={(e) => { handleOnChange(e) }}>
                                            <option value={''}>All Practices</option>
                                            {dropDownData?.domain?.length ? bindAllPracticesDropDownData() : ''}
                                        </select>
                                    </li>
                                    <li className="me-3">
                                        <div className="input-group flex-nowrap search-group me-2" style={{ position: 'relative' }}>
                                            <input type="search" className="form-control search-align" placeholder="Search" value={tempSearch}
                                                aria-label="Username" aria-describedby="addon-wrapping" onKeyDownCapture={(e) => { e.key == 'Enter' && setGridActions({ ...gridActions, ['searchData']: tempSearch.trim(), ['pageNumber']: 1, ['startDate']: '', ['endDate']: '' }) }} onChange={(e) => { setTempSearch(e.target.value) }} />
                                            <button className="input-group-text btn btn-search-custom" id="addon-wrapping" onClick={() => { setGridActions({ ...gridActions, ['searchData']: tempSearch.trim(), ['pageNumber']: 1, ['startDate']: '', ['endDate']: '' }); }}>
                                                <img
                                                    src="Images/Centcom/search-icon.svg" alt="search-icon" onClick={() => { setGridActions({ ...gridActions, ['searchData']: tempSearch.trim(), ['pageNumber']: 1 }) }} /></button>
                                        </div>
                                    </li>
                                    <li>
                                        {/* <!--Filter Section Starts Here--> */}
                                        <div className="dropdown">

                                            <button className="advanced-filter-button me-3 medium-text"
                                                type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown"
                                                aria-expanded="false" style={{ padding: "10px" }} onClick={() => { setFilterDisplay('block') }}>
                                                <img src="/Images/filter-icon.svg" alt="Filter-icon" className="me-2" />Filter</button>

                                            <div className="dropdown-menu custom-filter-centcom shadow-sm border-0 p-3 filter-zindex" style={{ display: { filterDisplay } }}>
                                                <div className="col-md-12">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span className="font-16 semibold-text advanced-filter-title ">Advanced Filter</span>
                                                        <button type="button" className="btn-close" data-bs-dismiss="modal"
                                                            aria-label="Close"></button>
                                                    </div>
                                                    <div className="row mt-3">

                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="mb-3">
                                                                <label className="form-label hive-form-label">Skill Set</label>

                                                                <select className="form-select hive-form-select mt-2"
                                                                    aria-label="Default select example" value={skillFilter} onChange={(e) => { setSkillFilter(e.target.value) }}>
                                                                    <option selected hidden value={''}>Select</option>
                                                                    {dropDownData?.skill?.length ? bindSkillSetDropDownData() : ''}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="mb-3">

                                                                <label className="form-label hive-form-label">Project</label>
                                                                <select className="form-select hive-form-select mt-2"
                                                                    aria-label="Default select example" value={ProjectFilter} onChange={(e) => { setProjectFilter(e.target.value) }}>
                                                                    <option selected hidden value={''}>Select</option>
                                                                    {dropDownData?.projects?.length ? bindProjectsDropDownData() : ''}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-3">

                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="mb-3">
                                                                <label className="form-label hive-form-label">Rating</label>

                                                                <select className="form-select hive-form-select mt-2"
                                                                    aria-label="Default select example" value={ratingFilter} onChange={(e) => { setratingFilter(e.target.value) }}>
                                                                    <option selected hidden value={''}>Select</option>
                                                                    <option value="A+">A+</option>
                                                                    <option value="A-">A-</option>
                                                                    <option value="B+">B+</option>
                                                                    <option value="B-">B-</option>
                                                                    <option value="C+">C+</option>
                                                                    <option value="C-">C-</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="mb-3">

                                                                <label className="form-label hive-form-label">Billing</label>
                                                                <select className="form-select hive-form-select mt-2"
                                                                    aria-label="Default select example" value={billingFilter} onChange={(e) => { setbillingFilter(e.target.value) }}>
                                                                    <option selected hidden value={''}>Select</option>
                                                                    <option value="Billable">Billable</option>
                                                                    <option value="Non Billable">Non Billable</option>
                                                                    <option value="Partially Billable">Partially Billable</option>
                                                                    <option value="Others">Others</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-3">

                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="mb-3">
                                                                <label className="form-label hive-form-label">Experience</label>

                                                                <input type='text' className="form-control hive-form-select mt-2"
                                                                    aria-label="Default select example" value={experienceFilter}
                                                                    onChange={(e) => {
                                                                        if (e.target.value.match(/^\d*\.?\d+$/) && e.target.value.length <= 2) {
                                                                            setexperienceFilter(e.target.value)
                                                                        }
                                                                        else if (e.target.value == "") {
                                                                            setexperienceFilter(e.target.value)
                                                                        }
                                                                    }} />


                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 my-3 d-flex justify-content-end">
                                                        <button type="button"
                                                            onClick={() => { clearFilter() }}
                                                            className="btn hive-btn-secondary me-3">
                                                            Clear
                                                        </button>
                                                        <button type="button"
                                                            className="btn hive-btn-primary" onClick={() => {
                                                                setGridActions({ ...gridActions, ['skill']: skillFilter, ['project_name']: ProjectFilter, ['pageNumber']: 1, ['rating']: ratingFilter, ['experience']: experienceFilter, ['billing']: billingFilter })
                                                            }

                                                            } disabled={skillFilter || ProjectFilter || ratingFilter || billingFilter || experienceFilter ? false : true}>
                                                            Apply
                                                        </button>
                                                    </div>

                                                </div>
                                                {/* <!--Filter Section Ends Here--> */}
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="table-responsive deli-track" style={{ height: '72dvh', overflowY: 'scroll', scrollbarWidth: '0px' }}>
                            <table className="table text-nowrap mb-0 table-borderless delivery-table-head">
                                <colgroup>
                                    <col span="1" width="22%" />
                                </colgroup>
                                <thead className='sticky-top'>
                                    <tr>
                                        <th className="tt-bold font-15 text-start">Employee Name<span>
                                            {gridActions.nameOrder == "desc" && <img src="Images/Centcom/down-arrow.svg" style={{ transform: 'rotate(180deg)' }} alt="sort-icon" width="10px" className="ms-1 cursor-pointer" id='nameOrder' onClick={(e) => { sortAsc(e) }} />}
                                            {gridActions.nameOrder != "desc" && <img src="Images/Centcom/down-arrow.svg" alt="sort-icon" width="10px" className="ms-1 cursor-pointer" id='nameOrder' onClick={(e) => { sortDesc(e) }} />}
                                        </span>
                                        </th>
                                        <th className="cust-border-start tt-bold font-15 text-start">Exp<span>
                                            {gridActions.expOrder == "desc" && <img src="Images/Centcom/down-arrow.svg" style={{ transform: 'rotate(180deg)' }} alt="sort-icon" width="10px" className="ms-1 cursor-pointer" id='expOrder' onClick={(e) => { sortAsc(e) }} />}
                                            {gridActions.expOrder != "desc" && <img src="Images/Centcom/down-arrow.svg" alt="sort-icon" width="10px" className="ms-1 cursor-pointer" id='expOrder' onClick={(e) => { sortDesc(e) }} />}
                                        </span></th>
                                        <th className="cust-border-start tt-bold font-15 text-start">Skill Set</th>
                                        <th className="cust-border-start tt-bold font-15 text-start">Rating</th>
                                        <th className="cust-border-start tt-bold font-15 text-start">Billable</th>
                                        {/* <th className="cust-border-start tt-bold font-15 text-start">Project</th> */}
                                        <th className="text-center cust-border-bottom cust-border-start tt-bold font-15" colspan="4"><button className="btn btn-toggle shadow " type="button" onClick={() => { getThreeWeeksRange(entireWeekRange.start_date, entireWeekRange.end_date, 'previous') }}><img src="Images/Centcom/left-arrow.svg" alt="left-icon" /></button><span className="px-3">Week {weekNo?.length ? weekNo[0] : '1'} - Week {weekNo?.length ? weekNo[2] : '3'}</span><button className="btn btn-toggle shadow " type="button" onClick={() => { getThreeWeeksRange(entireWeekRange.start_date, entireWeekRange.end_date, 'next') }}><img src="Images/Centcom/right-arrow.svg" alt="right-icon" /></button></th>
                                    </tr>
                                    <tr>
                                        {/* <th></th> */}
                                        <th className="cust-border-start tt-bold font-15"></th>
                                        <th className="cust-border-start tt-bold font-15"></th>
                                        <th className="cust-border-start tt-bold font-15"></th>
                                        <th className="cust-border-start tt-bold font-15"></th>
                                        <th className="cust-border-start tt-bold font-15"></th>
                                        <th className="cust-border-start tt-bold font-13">{weekRange?.length && weekRange[0]?.status == "Other Week" ? weekRange?.length && `${weekRange[0]?.start}-${weekRange[0]?.end}` : weekRange?.length && weekRange[0]?.status}</th>
                                        <th className="cust-border-start tt-bold font-13">{weekRange?.length && weekRange[1]?.status == "Other Week" ? `${weekRange?.length && weekRange[1]?.start}-${weekRange[1]?.end}` : weekRange?.length && weekRange[1]?.status}</th>
                                        <th className="cust-border-start tt-bold font-13" colspan="2">{weekRange?.length && weekRange[2]?.status == "Other Week" ? `${weekRange?.length && weekRange[2]?.start}-${weekRange[2]?.end}` : weekRange?.length && weekRange[2]?.status}</th>
                                    </tr>
                                </thead>
                                <tbody className="delivery-table-body">
                                    {gridData?.length ? bindFunction() :
                                        <tr>
                                            <td className="text-center" colspan="12">
                                                <img className="my-5" src="Images/Centcom/no-records-found.svg" alt="no-records-found-icon" width="170px" />
                                                <h5 className="font-bold font-22 mb-4"> {gridActions?.searchData ? "Result Not Found" : "No Records Found"} </h5>
                                                {gridActions?.searchData && <p className="w-100 font-medium font-18 custom-label-color mb-2">We couldn’t find any search results against "{gridActions.searchData}" </p>}
                                                {gridActions?.searchData && <p className="w-100 font-medium font-18 custom-label-color">Try searching with other keywords</p>}
                                            </td>
                                        </tr>}
                                </tbody>
                            </table>

                        </div>
                        <div className="d-flex justify-content-between mt-3 align-items-center">
                            <div>
                                <p className="m-0 font-12 text-grey">Showing <span className="font-13 font-bold text-black">{recordCount ? ((gridActions.pageNumber * 30 - 30) + 1) : recordCount} - {(gridActions?.pageNumber * 30 > recordCount ? recordCount : gridActions.pageNumber * 30)}</span> out of <span className="font-13 font-bold text-black">{gridData?.length === 0 ? 0 : recordCount}</span> items</p>
                            </div>
                            <div>
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination mb-0">
                                        <li className={`page-item ${gridActions.pageNumber === 1 ? `disabled` : `cursor-pointer`}`} id='first-page' onClick={(e) => { handlePagesOnclick(e) }}>
                                            <a className="page-link cursor-pointer" aria-label="first" id='first-page' onClick={(e) => { handlePagesOnclick(e) }}>
                                                <span aria-hidden="true" id='first-page' className='cursor-pointer' onClick={(e) => { handlePagesOnclick(e) }}>
                                                    <img className='rotate-180' src={`${gridActions.pageNumber == 1 ? "Images/right-double-disabled" : "Images/right-double-enabled"}.svg`} alt="Double Arrow" width="5px" id='first-page' onClick={(e) => { handlePagesOnclick(e) }} />
                                                </span>
                                            </a>
                                        </li>
                                        <li className={`page-item ${gridActions.pageNumber === 1 ? `disabled` : `cursor-pointer`}`} id='previous-page' onClick={(e) => { handlePagesOnclick(e) }}>
                                            <a className="page-link cursor-pointer" aria-label="previous" id='previous-page' onClick={(e) => { handlePagesOnclick(e) }}>
                                                <span aria-hidden="true" className='cursor-pointer'><img src={`${gridActions.pageNumber === 1 ? "Images/Centcom/right-disabled arrow" : "Images/Centcom/Single-arrow"}.svg`} alt="Double Arrow" width="5px" className="rotate-180" id='previous-page' onClick={(e) => { handlePagesOnclick(e) }} /></span>
                                            </a>
                                        </li>

                                        <li className="page-item"><a className="page-link">{gridActions.pageNumber}</a></li>
                                        <li className={`page-item ${gridActions.pageNumber == numberOfPages || numberOfPages == 0 ? `disabled` : `cursor-pointer`}`} id='next-page' onClick={(e) => { handlePagesOnclick(e) }}>
                                            <a className="page-link cursor-pointer" aria-label="Next" id='next-page' onClick={(e) => { handlePagesOnclick(e) }}>
                                                <span aria-hidden="true" className='cursor-pointer'><img src={`${gridActions.pageNumber == numberOfPages || numberOfPages == 0 ? "Images/Centcom/right-disabled arrow" : "Images/Centcom/Single-arrow"}.svg`} alt="Double Arrow" width="5px" id='next-page' onClick={(e) => { handlePagesOnclick(e) }} /></span>
                                            </a>
                                        </li>
                                        <li className={`page-item ${gridActions.pageNumber == numberOfPages || numberOfPages == 0 ? `disabled` : `cursor-pointer`}`} id='last-page' onClick={(e) => { handlePagesOnclick(e) }}>
                                            <a className="page-link cursor-pointer" aria-label="Last" id='last-page' onClick={(e) => { handlePagesOnclick(e) }}>
                                                <span aria-hidden="true" className='cursor-pointer' >
                                                    <img src={`${gridActions.pageNumber == numberOfPages || numberOfPages == 0 ? "Images/right-double-disabled" : "Images/right-double-enabled"}.svg`} alt="Double Arrow" width="5px" id='last-page' onClick={(e) => { handlePagesOnclick(e) }} />
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>


                        </div>
                    </div>
                    {/* : <></>} */}


                    {/* <!-- Modal --> */}
                    {/* <div class="modal-backdrop modal-zindex fade show" style={{ display: `${editDisplay == true ? "block" : "none"}` }}></div>
                    <div className="modal fade show modal-zindex ganttPopupViewm mt-5" style={{ display: `${editDisplay == true ? "block" : "none"}` }} id="ganttPopup" tabindex="-1" aria-labelledby="ganttPopup" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header border-0">
                                    <p className="font-18 semibold-text advanced-filter-title mt-2" id="">Edit Task Details</p>
                                    <button type="button" onClick={() => { setEditDisplay(false); clearErrorMessages() }} className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="pb-3">
                                        <label for="taskTitle" className="form-label hive-form-label">Title <span className="mandatory">*</span></label>
                                        <input type="text" name='task_name' value={editData.task_name} className="form-control font-13 text-black" id="taskTitle" aria-describedby="task-title" placeholder="Task title" onChange={(e) => { editHandleOnCHange(e) }} />
                                        {errorMsg.title ? <span style={{ color: 'red', fontSize: 'x-small' }}>{errorMsg.title}</span> : <></>}
                                    </div>
                                    <div className="pb-3 pt-2 d-flex">
                                        <div className="w-50 pe-4">
                                            <label for="estimatedHrs" className="form-label hive-form-label">Estimated Effort (hr) <span className="mandatory">*</span></label>
                                            <input type="text" name='ETA' value={editData.ETA} className="form-control font-13 text-black" disabled={currentClubbedId} id="estimatedHrs" aria-describedby="estimated-Hrs" placeholder="Estimated Effort" onChange={(e) => { editHandleOnCHange(e) }} />
                                            {errorMsg.estHrs ? <span style={{ color: 'red', fontSize: 'x-small' }}>{errorMsg.estHrs}</span> : <></>}
                                        </div>
                                        <div className="w-50 ps-4">
                                            <label for="taskType" className="form-label hive-form-label">Type of Task <span className="mandatory">*</span></label>
                                            <input type="text" value={editData.type} className="form-control font-13 text-black" disabled={currentClubbedId} id="taskType" name='type' aria-describedby="task-type" placeholder="Task type" onChange={(e) => { editHandleOnCHange(e) }} />
                                            {errorMsg.taskType ? <span style={{ color: 'red', fontSize: 'x-small' }}>{errorMsg.taskType}</span> : <></>}
                                        </div>
                                    </div>
                                    <div className="pb-3 pt-2 form-group">
                                        <label for="additionalNotes" className="form-label hive-form-label">Additional Notes <span className="mandatory">*</span></label>
                                        <textarea className="form-control font-13" name="comments" disabled={currentClubbedId} value={editData.comments} id="comments" rows="3" onChange={(e) => { editHandleOnCHange(e) }}></textarea>
                                        {errorMsg.notes ? <span style={{ color: 'red', fontSize: 'x-small' }}>{errorMsg.notes}</span> : <></>}
                                    </div>
                                    <div className="pb-3 pt-2">
                                        <label for="taskTags" className="form-label hive-form-label" disabled={currentClubbedId}>Tags <span className="mandatory">*</span></label>
                                        <Select
                                            mode="multiple"
                                            allowClear
                                            style={{ width: "100%" }}
                                            placeholder="Please select the tags"
                                            value={multiTags}
                                            onChange={handleChange}
                                            options={options}
                                            size={"large"}
                                            virtual={false}
                                            disabled={currentClubbedId}
                                        >
                                        </Select>
                                        {errorMsg.tags ? <span style={{ color: 'red', fontSize: 'x-small' }}>{errorMsg.tags}</span> : <></>}
                                    </div>
                                </div>

                                <div className="modal-footer p-0 border-0" style={{ margin: '0 20px 10px 0' }} >
                                    <button type="button" className="btn hive-btn-secondary me-3" onClick={() => { setEditDisplay(false); setCurrentClubbedId(false); setMultiTags([]); clearErrorMessages() }} data-bs-dismiss="modal">Cancel</button>
                                    <button type="button" className="btn hive-btn-primary" onClick={() => { updateDetails() }}>Update Info</button>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>}
        </div>

    )
}

export default Grid;